import { render, staticRenderFns } from "./CoursewareUnitItems.vue?vue&type=template&id=face00e2&"
import script from "./CoursewareUnitItems.vue?vue&type=script&lang=js&"
export * from "./CoursewareUnitItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports